<script setup>
import { computed } from 'vue'
import { useAttrs } from 'vue'
import { mdiIcons } from '@/plugins/GlobalMdiIcons'

const props = defineProps({
  icon: { type: String, required: true },
  size: { type: [Number, String], default: 24 },
  placeholder: { type: Boolean, default: false } // zostaje dla kompatybilności
})

const attrs = useAttrs()

const iconComponent = computed(() => {
  // jeśli nie znajdzie — pokaże ikonę pomocy
  return mdiIcons[props.icon] ?? mdiIcons['Help']
})
</script>

<template>
  <component
    :is="iconComponent"
    :size="size"
    v-bind="attrs"
    class="fill-current inline-block align-middle"
  />
</template>
